import { ConvexReactClient } from "convex/react";

export const client = new ConvexReactClient(process.env.REACT_APP_CONVEX_URL);
